import React from "react";
import SbEditable from "storyblok-react";
import Heading from "src/components/Heading";
import Button from "src/components/Button";
import RichText from "src/utils/RichText";

const ThankYou = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="mx-auto px-6 my-16 max-w-2xl text-center md:my-24 lg:my-20">
        { blok?.image?.filename && 
          <img className="mx-auto mb-10 md:mb-14 max-w-[60vw] md:max-w-[300px]" src={blok?.image?.filename} alt={blok?.image?.alt}/>
        }
        <Heading className="text-darkblue mb-12 block" size="h2">
          {blok.title}
        </Heading>
        <div className="text-darkblue-700 tracking-[-0.03em]">
          <RichText>{blok.content}</RichText>
        </div>
        <Button
          to={`/${blok.button_target.cached_url}`}
          before={blok.button_label}
          className={`bg-brightgreen hover:bg-brightgreenhover mr-3 mt-10 before:content-[attr(before)]`}
        >
          {blok.button_label}
        </Button>
      </div>
    </SbEditable>
  );
};

export default ThankYou;
